<template>
  <div class="booking-requests" :class="{ 'soft-border': softBorder }">
    <v-textarea
      :value="bookingRequests"
      outlined
      label="Bokningskommentarer"
      prepend-inner-icon="mdi-message-text-outline"
      auto-grow
      no-resize
      rows="3"
      disabled
    >
      <template v-if="isSkeletonLoader" v-slot:[`prepend-inner`]>
        <v-icon style="height: 24px;">mdi-tag-text-outline</v-icon>
        <div style="height: 0; width: 0; overflow: visible;">
          <v-skeleton-loader
            class="ml-3"
            style="width: 180px;"
            type="paragraph"
          ></v-skeleton-loader>
        </div>
      </template>
    </v-textarea>
  </div>
</template>

<script>

export default {
  name: 'BookingRequests',
  props: {
    softBorder: Boolean,
    bookingRequests: String,
    isSkeletonLoader: Boolean
  },
  data: () => ({}),
  computed: {},
  methods: {}
}
</script>
